<script lang="ts" setup>
import type { Context } from '../../types/content'

const contextsStore = useContextsStore()
const isEditingContext = ref<boolean>(false)

const { t } = useI18n()
const { context } = defineProps<{
  context: Context
}>()

const emit = defineEmits<{
  (e: 'select'): void
}>()

const menuItems = [
  {
    label: t('edit'),
    icon: 'i-mingcute-pencil-line',
    onClick: () => {
      isEditingContext.value = true
    }
  },
  {
    label: t('delete'),
    icon: 'i-mingcute-delete-line',
    onClick: () => {
      handleDeleteContext()
    }
  }
]

async function handleDeleteContext() {
  await contextsStore.removeContext(context.id)

  const toast = useToast()
  const toastInstance = toast.add({
    title: t('contexts.deleted'),
    icon: 'i-mingcute-delete-line',
    duration: 5000,
    actions: [
      {
        label: t('undo'),
        size: 'md',
        onClick: async () => {
          await contextsStore.restoreContext(context.id)
          toast.remove(toastInstance.id)
        }
      }
    ]
  })
}

function handleSelectContext(context: Context) {
  contextsStore.setCurrentContext(context)
  emit('select')
}
function handleFinishEditingContext() {
  isEditingContext.value = false
}
</script>

<template>
  <section>
    <ContextEditionItem
      v-if="isEditingContext"
      :key="context.id"
      :context="context"
      @end="handleFinishEditingContext"
    />
    <div v-else class="flex gap-2">
      <UButton
        variant="solid"
        size="xl"
        class="flex-1 flex text-inverted items-center justify-between gap-2"
        :style="{
          backgroundColor: `var(--color-context-${context.color})`
        }"
        @click="handleSelectContext(context)"
      >
        <span class="flex-1 truncate text-left">
          {{ context.name }}
        </span>
        <UIcon
          v-if="context.id === contextsStore.currentContext?.id"
          name="i-mingcute-check-line"
          class="ml-auto"
          size="24"
        />
      </UButton>
      <UDropdownMenu :items="menuItems" size="xl">
        <UButton
          variant="ghost"
          color="neutral"
          size="xl"
          icon="i-mingcute-more-2-line"
        />
      </UDropdownMenu>
    </div>
  </section>
</template>
